/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueTeamStatus } from './LeagueTeamStatus';
import {
    LeagueTeamStatusFromJSON,
    LeagueTeamStatusFromJSONTyped,
    LeagueTeamStatusToJSON,
    LeagueTeamStatusToJSONTyped,
} from './LeagueTeamStatus';
import type { LeagueRosterMemberResponse } from './LeagueRosterMemberResponse';
import {
    LeagueRosterMemberResponseFromJSON,
    LeagueRosterMemberResponseFromJSONTyped,
    LeagueRosterMemberResponseToJSON,
    LeagueRosterMemberResponseToJSONTyped,
} from './LeagueRosterMemberResponse';

/**
 * Team registered in a league with standings stats
 * @export
 * @interface LeagueTeam
 */
export interface LeagueTeam {
    /**
     * 
     * @type {string}
     * @memberof LeagueTeam
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof LeagueTeam
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof LeagueTeam
     */
    updatedAt: number;
    /**
     * ID of the league
     * @type {string}
     * @memberof LeagueTeam
     */
    leagueId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueTeam
     */
    name: string;
    /**
     * Short team tag, e.g. "TSM"
     * @type {string}
     * @memberof LeagueTeam
     */
    tag?: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueTeam
     */
    logoUrl?: string;
    /**
     * Captain's odId
     * @type {string}
     * @memberof LeagueTeam
     */
    captainOdId: string;
    /**
     * 
     * @type {Array<LeagueRosterMemberResponse>}
     * @memberof LeagueTeam
     */
    roster: Array<LeagueRosterMemberResponse>;
    /**
     * Division ID for multi-division leagues
     * @type {string}
     * @memberof LeagueTeam
     */
    divisionId?: string;
    /**
     * Current standings position
     * @type {number}
     * @memberof LeagueTeam
     */
    position: number;
    /**
     * Team stats (played, wins, draws, losses, goalsFor, goalsAgainst, goalDifference, points, form, home/away splits, cleanSheets)
     * @type {object}
     * @memberof LeagueTeam
     */
    stats?: object;
    /**
     * 
     * @type {LeagueTeamStatus}
     * @memberof LeagueTeam
     */
    status: LeagueTeamStatus;
    /**
     * 
     * @type {number}
     * @memberof LeagueTeam
     */
    registeredAt: number;
}



/**
 * Check if a given object implements the LeagueTeam interface.
 */
export function instanceOfLeagueTeam(value: object): value is LeagueTeam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('leagueId' in value) || value['leagueId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('captainOdId' in value) || value['captainOdId'] === undefined) return false;
    if (!('roster' in value) || value['roster'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('registeredAt' in value) || value['registeredAt'] === undefined) return false;
    return true;
}

export function LeagueTeamFromJSON(json: any): LeagueTeam {
    return LeagueTeamFromJSONTyped(json, false);
}

export function LeagueTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'leagueId': json['leagueId'],
        'name': json['name'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'captainOdId': json['captainOdId'],
        'roster': ((json['roster'] as Array<any>).map(LeagueRosterMemberResponseFromJSON)),
        'divisionId': json['divisionId'] == null ? undefined : json['divisionId'],
        'position': json['position'],
        'stats': json['stats'] == null ? undefined : json['stats'],
        'status': LeagueTeamStatusFromJSON(json['status']),
        'registeredAt': json['registeredAt'],
    };
}

export function LeagueTeamToJSON(json: any): LeagueTeam {
    return LeagueTeamToJSONTyped(json, false);
}

export function LeagueTeamToJSONTyped(value?: LeagueTeam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'leagueId': value['leagueId'],
        'name': value['name'],
        'tag': value['tag'],
        'logoUrl': value['logoUrl'],
        'captainOdId': value['captainOdId'],
        'roster': ((value['roster'] as Array<any>).map(LeagueRosterMemberResponseToJSON)),
        'divisionId': value['divisionId'],
        'position': value['position'],
        'stats': value['stats'],
        'status': LeagueTeamStatusToJSON(value['status']),
        'registeredAt': value['registeredAt'],
    };
}

